<template>
  <form class="login-form" action="" @submit.prevent="">
    <TextField :data="textField" class="login-form__input login-form__input_text"/>
    <PasswordField :data="passwordField" class="login-form__input login-form__input_password"/>
    <div class="login-form__wrapper">
      <ControlCheckbox :data="checkboxControl" class="login-form__input login-form__input_checkbox"/>
      <SubmitButton class="login-form__button">
        Sign in
      </SubmitButton>
    </div>

  </form>
</template>

<script>
import TextField from '@/components/form-field/TextField'
import PasswordField from '@/components/form-field/PasswordField'
import SubmitButton from '@/components/button/Submit'
import ControlCheckbox from '@/components/control/Checkbox'

export default {
  name: 'Login',
  components: {
    PasswordField,
    TextField,
    SubmitButton,
    ControlCheckbox
  },
  data () {
    return {
      textField: {
        id: 'login',
        name: 'login',
        placeholder: 'Enter login',
        label: 'Login',
        required: true,
        validationRule: 'required|min:6'
      },
      passwordField: {
        id: 'password',
        name: 'password',
        placeholder: 'Enter password',
        label: 'Password',
        required: true,
        validationRule: 'required'
      },
      checkboxControl: {
        id: 'remember',
        name: 'remember',
        label: 'Remember me'
      }
    }
  }
}
</script>

<style lang="scss">
  .login-form {
    &__wrapper {
      display: flex;
      width: 300px;
      margin-top: 30px;
      margin-left: auto;
      margin-right: 41px;
      justify-content: space-between;
      align-items: center;
    }

    &__input {
      margin-left: -41px;

      &_text {
        margin-bottom: 30px;
      }

      &_checkbox {
        margin-top: 2px;
        margin-left: 0;
      }
    }

    &__button {
      width: 115px;
      background-color: #716aca;
      border-color: #716aca;
      color: #ffffff;

      &:active {
        background-color: #554dbd;
        border-color: #554dbd;
      }
    }
  }
</style>
